// src/components/PasswordReset.js
import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from "firebase/auth";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Alert
} from '@mui/material';
import AppBrandLogo from './AppBrandLogo';
import LoadingLockScreen from './LoadingLockScreen';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setSubmitting(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess("Check your email! A password reset link has been sent.");
    } catch (error) {
      console.error("Error sending password reset:", error);
      setError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 4 }}>
      <LoadingLockScreen open={submitting} />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <AppBrandLogo maxWidth={300} sx={{ mb: 2 }} />
        <Typography component="h2" variant="h5">
          Forgot Password
        </Typography>
        <Box component="form" onSubmit={handleReset} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email-reset"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={submitting}
          >
            Send Reset Email
          </Button>
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
        </Box>
      </Box>
    </Container>
  );
};

export default PasswordReset;